import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from 'components/button/button'
import Icon from 'components/icon/icon'

import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import {
    getCurrentUser,
    getCurrentAccount
} from 'state/selectors'

import moment from 'moment'

import { 
    isMobile
} from 'utils'

class ModalWelcomeBusiness extends Component {
    getLastSeenProjectInAccount = _ => {
        const {
            userData,
            allProjects,
            accountData
        } = this.props

        let lastSeenProjectInAccount = null

        if(!userData.project_last_opened){
            return
        }

        Object.keys(userData.project_last_opened).forEach(projectId => {
            const dateOpened = moment(userData.project_last_opened[projectId])

            if(!lastSeenProjectInAccount || lastSeenProjectInAccount.date.isBefore(dateOpened)){
                const projectObject = allProjects[projectId]

                if(projectObject && projectObject.account_id == accountData.id){
                    lastSeenProjectInAccount = {
                        date: dateOpened,
                        project: projectObject
                    }
                }
            }
        })

        if(lastSeenProjectInAccount){
            return lastSeenProjectInAccount.project
        }
    }

	render() {
        const {
            location,
            closeCallback,
            userData,
            data
        } = this.props

        const urlSegments = location.pathname.split('/')
        const baseUrl = '/'+urlSegments[1]

        const listItems = [
            {
                type: 'dashboard',
                icon: 'star',
                title: 'Enable new features on a <em>project</em>.',
                copy: `Edit a project to enable new features such as time tracking.`,
                url: '/projects'
            },{
                type: 'project',
                icon: 'fe-layout',
                title: 'Check out your updated <em>dashboard</em>.',
                copy: `Post an announcement, or create a calendar event.`,
                url: '/dashboard?showGettingStarted=1'
            },{
                type: 'team',
                icon: 'user-circle-o',
                title: 'Create a <em>team</em> or two.',
                copy: `Group your organization, and decide who can see what.`,
                url: '/people/teams'
            }
        ]

        const lastSeenProjectInAccount = this.getLastSeenProjectInAccount()

        if(lastSeenProjectInAccount){
            listItems[0].title = `Enable new features on <em>${lastSeenProjectInAccount.name}</em>`
            listItems[0].url = `/projects/${lastSeenProjectInAccount.slug}/tasks?openEdit`
        }

        const copy = (data && data.isExtension) ? {
            title: `Welcome back, ${ userData.first_name }!`,
            body: `We've added another 30 days to your Business trial. Here's some suggestions to get back into it 😊.`
        } : {
            title: `Welcome to Hassl, ${ userData.first_name }!`,
            body: `To get started, we suggest one of the following.`
        }

		return(
			<div className="modal-pricing">
                <h2>
                    { copy.title }
                </h2>
                <p>
                    { copy.body }
                </p>
                <ul className={'users-list list accounts-list'}>
                    { listItems.map(item => {
                        return (
                            <li key={item.type} className={'list-item'}>
                                <div onClick={_ => {
                                    closeCallback()
                                }}>
                                    <Link to={baseUrl+item.url}>
                                        <div className="profile-image account">
                                            <Icon name={item.icon} />
                                            <Icon name={item.icon} />
                                        </div>
                                        <div className={'user-meta'}>
                                            <h2 dangerouslySetInnerHTML={{ __html: item.title }} />
                                            <p dangerouslySetInnerHTML={{ __html: item.copy }} />
                                        </div>
                                    </Link>
                                </div>
                            </li>
                        )
                    })}
                </ul>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
        userData: getCurrentUser(state),
        accountData: getCurrentAccount(state),
        allProjects: state.account.entities.projects,
	}
}

export default withRouter(connect(mapStateToProps, {  })(ModalWelcomeBusiness))


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-welcome-business.jsx